import singleCoin from 'src/shared/assets/images/single-coin.png'
import { PointIcon } from 'src/shared/components/icons/point-icon'

import { Hexagon } from './icons/hexagon'

type RewardsRecapProps = {
  totalAcceptedInvites: number
  totalPoints: number
  totalQLC: number
}

const RewardsRecap = ({ totalAcceptedInvites = 0, totalPoints = 0, totalQLC = 0 }: RewardsRecapProps) => {
  return (
    <div className="flex flex-row items-center justify-between rounded-xl border border-white/20 bg-white/[0.07] p-4">
      <div className="flex max-w-[calc(100%-114px)] flex-col items-start justify-start gap-0.5">
        <h3 className="text-base font-bold text-white">Rewards so far</h3>
        <p className="text-sm leading-[18px] text-white/75">
          {totalAcceptedInvites} {totalAcceptedInvites === 1 ? 'person' : 'people'} accepted your invite and verified
          their profile
        </p>
      </div>

      <div className="flex flex-row items-center justify-end gap-1.5">
        <Hexagon color="rgba(255, 148, 22, 1)" size={49}>
          <div className="flex flex-col items-center justify-center gap-0.5 pt-1">
            <PointIcon size={21} className="text-white" />
            <span
              className="max-w-[42px] text-center text-base font-extrabold text-white"
              style={{ whiteSpace: 'nowrap' }}
            >
              +{totalPoints}
            </span>
          </div>
        </Hexagon>

        <Hexagon color="rgba(69, 216, 142, 1)" size={49}>
          <div className="flex flex-col items-center justify-center gap-0.5 pt-1">
            <img src={singleCoin} alt="QLC" className="size-[21px] object-contain" />
            <span
              className="max-w-[42px] text-center text-base font-extrabold text-white"
              style={{ whiteSpace: 'nowrap' }}
            >
              {totalQLC}
            </span>
          </div>
        </Hexagon>
      </div>
    </div>
  )
}

export default RewardsRecap
